// @flow

export const checks = [
    'isOutbrainDisabled',
    'isUserInContributionsAbTest',
    'isUserNotInContributionsAbTest',
    'isUserInEmailAbTest',
    'emailCanRunPreCheck',
    'listCanRun',
    'emailInArticleOutbrainEnabled',
    'hasHighPriorityAdLoaded',
    'hasLowPriorityAdLoaded',
    'hasLowPriorityAdNotLoaded',
    'isStoryQuestionsOnPage',
    'isOutbrainBlockedByAds',
    'isOutbrainMerchandiseCompliant',
    'isOutbrainMerchandiseCompliantOrBlockedByAds',
    'emailCanRun',
    'emailCanRunPostCheck',
];
